import script from "./StateTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./StateTab.vue?vue&type=script&setup=true&lang=ts"

import "./StateTab.vue?vue&type=style&index=0&id=976d17ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-976d17ec"]])

export default __exports__